import { BRAND_NAME } from "@/lib/brand";

export type FaqItem = { q: string; a: string };

/** Единый FAQ для UI и JSON-LD FAQPage. */
export const LANDING_FAQ_ITEMS: FaqItem[] = [
  {
    q: "Откуда берутся данные?",
    a: "Открытые источники по РФ: Wordstat, отраслевые материалы, сайты конкурентов и реестры. Утверждения привязываются к источникам и допущениям.",
  },
  {
    q: `Чем ${BRAND_NAME} лучше ChatGPT?`,
    a: "Структура отчёта 11+ страниц, scoring по 6 критериям, фокус на рынке РФ и экспорт PDF — это research-engine, а не свободный чат.",
  },
  {
    q: "Подходит ли отчёт для инвестора или банка?",
    a: "Да — формат рассчитан на показ команде, акселератору или инвестору: вердикт, цифры, конкуренты и рекомендации.",
  },
  {
    q: "Как подключить Enterprise или white-label?",
    a: "Оставьте заявку в тарифах — обсудим объём, пилот и интеграцию. Онлайн-оплата для этих планов не нужна.",
  },
  {
    q: "Безопасны ли данные идеи?",
    a: "Хостинг в РФ, доступ только у вас в кабинете. Данные не используются для обучения сторонних моделей.",
  },
];
